function moduleTeamGrid() {
	const modules = document.querySelectorAll('.module.team-grid');
	if (!modules || !modules.length) return;

	const hideDialog = (dialog, grid) => {
		dialog.classList.remove('is-open');

		const dialogId = dialog.getAttribute('id');
		const card = grid.querySelector(`.team-card[data-dialog="${dialogId}"]`);
		if (card) {
			card.classList.remove('is-open');
		}
	};

	const hideAllDialogs = (grid) => {
		grid.querySelectorAll('.team-dialog.is-open').forEach(dialog => {
			hideDialog(dialog, grid);
		});
	};

	const showDialog = (dialog, card, grid) => {
		const cards = Array.from(grid.querySelectorAll('.team-card'));
		const cardTop = card.offsetTop;
		let lastCardInRow = card;

		for (let i = cards.indexOf(card) + 1; i < cards.length; i++) {
			if (cards[i].offsetTop === cardTop) {
				lastCardInRow = cards[i];
			} else {
				break;
			}
		}

		lastCardInRow.after(dialog);

		dialog.classList.add('is-open');
		card.classList.add('is-open');

		const arrow = dialog.querySelector('.dialog-arrow');
		if (arrow) {
			const cardRect = card.getBoundingClientRect();
			const dialogRect = dialog.getBoundingClientRect();
			arrow.style.left = `${cardRect.left - dialogRect.left + (cardRect.width / 2)}px`;
		}
	};

	const initModule = (module) => {
		const grid = module.querySelector('.team-grid-container');
		if (!grid) return;

		grid.addEventListener('click', (e) => {
			const card = e.target.closest('.team-card.has-content');
			const closeButton = e.target.closest('.dialog-close');

			if (card) {
				e.preventDefault();
				const dialogId = card.getAttribute('data-dialog');
				const dialog = document.getElementById(dialogId);

				if (!dialog) return;

				const isOpen = dialog.classList.contains('is-open');

				hideAllDialogs(grid);

				if (!isOpen) {
					showDialog(dialog, card, grid);
				}
			}

			if (closeButton) {
				e.preventDefault();
				const dialog = closeButton.closest('.team-dialog');
				if (dialog) {
					hideDialog(dialog, grid);
				}
			}
		});

		document.addEventListener('click', (e) => {
			if (!e.target.closest('.team-grid-container')) {
				hideAllDialogs(grid);
			}
		});
	};

	for (const module of modules) {
		initModule(module);
	}

	window.addEventListener('resize', () => {
		document.querySelectorAll('.team-dialog.is-open').forEach(dialog => {
			const closeButton = dialog.querySelector('.dialog-close');
			if (closeButton) closeButton.click();
		});
	});
}
